<app-formulario #ctrl URL="cambiar-grupo" titulo="Control Escolar / Cambiar grupo" [dato]="dato"></app-formulario>
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-hidden-mobile menu-izquierda is-2">
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">
      <!-- formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar(false, true)">
        <section class="hero is-primary">
          <div class="hero-body">
            <nav class="level">
              <!-- Left side -->
              <div class="level-left">
                <div class="level-item">
                  <p class="title">
                    <span *ngIf="!ctrl.cargando" class="icon is-medium">
                      <i class="icon-exchange-2"></i>
                    </span>
                    <span *ngIf="ctrl.cargando" class="icon is-medium">
                      <i class="fa fa-refresh fa-spin"></i>
                    </span>
                    <span class="icon is-medium">
                      <i class="fa fa-file"></i>
                    </span> Cambiar Grupo
                  </p>
                </div>

              </div>

              <!-- Right side -->
              <div class="level-right">
                <a class="navbar-item tooltip" (click)="ctrl.regresar()">
                  <span class="icon fa-2x">
                    <i class="fa fa-arrow-left"> </i>
                  </span>
                  <span class="tooltiptext">Regresar</span>
                </a>

                <button class="navbar-item  is-success tooltip" type="submit" [ngClass]="{'is-loading': ctrl.cargando}"
                  [disabled]="ctrl.dato.invalid || ctrl.cargando">
                  <span class="icon fa-2x has-text-success">
                    <i class="fa fa-save"> </i>
                  </span>
                  <span class="tooltiptext">Guardar</span>
                </button>
              </div>
            </nav>

          </div>
        </section>

        <div id="banner" align="center" *ngIf="ctrl.cargando || cargarDatosCatalogo">
          <div class="bloquear-azul">

          </div>
          <span class="tag is-primary is-large "
            style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
            <span class="icon">
              <i class="fa fa-refresh fa-spin"></i>
            </span> &nbsp;
            <span>Cargando...</span>
          </span>
        </div>

        <section class="section" style="padding: 1rem; height: 87.2vh;">

          <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
          <a id="catalogos"
            (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar-catalogo'); ctrl.cargarCatalogo('carreras_planes', 'carrera-plan');"></a>


          <div class="columns">
            <div class="column is-4">
              <label class="label has-text-warning">Carrera plan</label>
              <div class="control has-icons-left has-icons-right">
                <div class="select">
                  <ng-select2 [disabled]="ctrl.carreras_planes ? ctrl.carreras_planes.length == 0 ? true : false : true"
                    (valueChanged)="ctrl.dato.grupos = []; ctrl.dato.get('grupos_id').patchValue(''); ctrl.dato.get('carreras_planes_destino_id').patchValue('');  ctrl.dato.get('periodos_escolares_destino_id').patchValue(''); ctrl.dato.get('grupos_destino_id').patchValue(''); ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.carreras_planes_id);"
                    [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.carreras_planes_id.value"
                    [data]="ctrl.carreras_planes"></ng-select2>
                </div>
                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required') ">
                  <i class="fa fa-warning"></i>
                </span>
                <span class="help is-danger" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required') ">Este
                  campo es requerido.</span>
              </div>
            </div>

            <div class="column is-4">
              <label class="label has-text-warning">Período Escolar Origen</label>
              <div class="control has-icons-left has-icons-right">
                <div class="select">
                  <ng-select2 [disabled]="ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true"
                    (valueChanged)="ctrl.grupos = []; ctrl.dato.grupos = []; ctrl.dato.get('grupos_id').patchValue(''); ctrl.dato.get('carreras_planes_destino_id').patchValue('');  ctrl.dato.get('periodos_escolares_destino_id').patchValue(''); ctrl.dato.get('grupos_destino_id').patchValue(''); ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.periodos_escolares_id, 'listar-grupos-origen?carreras_planes_id='+ctrl.dato.get('carreras_planes_id').value, 'grupos');"
                    [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.periodos_escolares_id.value"
                    [data]="ctrl.periodos_escolares"></ng-select2>
                </div>
                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required') ">
                  <i class="fa fa-warning"></i>
                </span>
                <span class="help is-danger" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required') ">Este
                  campo es requerido.</span>
              </div>
            </div>

            <div class="column is-4">
              <label class="label has-text-warning">Grupo Origen</label>
              <div class="control has-icons-left has-icons-right">
                <a id="detalleGrupo" (click)="detalleGrupo(ctrl.dato.get('grupos_id').value);"></a>
                <div class="select">
                  <ng-select2 [disabled]="ctrl.grupos ? ctrl.grupos.length == 0 ? true : false : true"
                    (valueChanged)="ctrl.dato.get('carreras_planes_destino_id').patchValue(''); ctrl.dato.get('periodos_escolares_destino_id').patchValue(''); ctrl.dato.get('grupos_destino_id').patchValue(''); ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.grupos_id, '', '', 'detalleGrupo');"
                    [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.grupos_id.value" [data]="ctrl.grupos">
                  </ng-select2>
                </div>
                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('grupos_id').hasError('required') ">
                  <i class="fa fa-warning"></i>
                </span>
                <span class="help is-danger" *ngIf="ctrl.dato.get('grupos_id').hasError('required') ">Este campo es
                  requerido.</span>
              </div>
            </div>

          </div>

          <div class="box" *ngIf="carrera_plan">
            <article class="media">
              <div class="media-content" style="padding: 0px;">
                
                <div class="columns" style="margin: 0px;">
                  <div class="column is-4" *ngIf="!grupo.tiene_calificacion ">
                    <label class="label has-text-warning">Carrera plan</label>
                    <div class="control has-icons-left has-icons-right">
                      <div class="select">
                        <ng-select2 [disabled]="ctrl.carreras_planes ? ctrl.carreras_planes.length == 0 ? true : false : true"
                          (valueChanged)="ctrl.dato.grupos_destino = []; ctrl.dato.get('grupos_destino_id').patchValue(''); ctrl.dato.get('periodos_escolares_destino_id').patchValue(''); ctrl.dato.get('grupos_destino_id').patchValue(''); ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.carreras_planes_destino_id);"
                          [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.carreras_planes_destino_id.value"
                          [data]="ctrl.carreras_planes"></ng-select2>
                      </div>
                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('carreras_planes_destino_id').hasError('required') ">
                        <i class="fa fa-warning"></i>
                      </span>
                      <span class="help is-danger" *ngIf="ctrl.dato.get('carreras_planes_destino_id').hasError('required') ">Este
                        campo es requerido.</span>
                    </div>
                  </div>

                  <div class="column " ngClass="!grupo.tiene_calificacion ? 'is-4' : 'is-6'">
                    <label class="label has-text-success">Período escolar Destino</label>
                    <div class="control has-icons-left has-icons-right">
                      <div class="select">
                        <ng-select2 [disabled]="ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true"
                          (valueChanged)="ctrl.grupos_destino = []; ctrl.dato.get('grupos_destino_id').patchValue(''); ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.periodos_escolares_destino_id, 'listar-grupos-destino?grupos_id='+ctrl.dato.get('grupos_id').value+'&carreras_planes_id='+ctrl.dato.get('carreras_planes_id').value+'&carreras_planes_destino_id='+ctrl.dato.get('carreras_planes_destino_id').value, 'grupos_destino'); "
                          [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.periodos_escolares_destino_id.value"
                          [data]="ctrl.periodos_escolares"></ng-select2>
                      </div>
                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required') ">
                        <i class="fa fa-warning"></i>
                      </span>
                      <span class="help is-danger" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required') ">Este
                        campo es requerido.</span>
                    </div>
                  </div>

                  <div class="column " ngClass="!grupo.tiene_calificacion ? 'is-4' : 'is-6'">
                    <label class="label has-text-success">Grupo Destino</label>
                    <div class="control has-icons-left has-icons-right">
                      <div class="select">
                        <ng-select2 [disabled]="ctrl.grupos_destino ? ctrl.grupos_destino.length == 0 ? true : false : true"
                          [options]="ctrl.optionSelect" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.grupos_destino_id)"
                          [value]="ctrl.dato.controls.grupos_destino_id.value" [data]="ctrl.grupos_destino"></ng-select2>
                      </div>
                      <span class="icon is-small is-right" *ngIf="ctrl.dato.get('grupos_destino_id').hasError('required') ">
                        <i class="fa fa-warning"></i>
                      </span>
                      <span class="help is-danger" *ngIf="ctrl.dato.get('grupos_destino_id').hasError('required') ">Este
                        campo es requerido.</span>
                    </div>
                  </div>
                </div>
                <nav class="level" style="margin: 0px;">
                  <div lass="level-left">
                    <div class="level-item">
                      <p aling="center">
                        <span class="has-text-primary">
                          <i class="fa fa-info-circle is-size-3 has-text-grey-light"> </i>
                          Los alumnos de la lista que estén marcados serán migrados al "Grupo Destino", El sistema pone a
                          disposición los grupos que corresponden a la carrera y nivel para poder cambiarlo. Verifique la
                          información antes de guardar
                        </span>
                      </p>
                    </div>
                  </div>
                </nav>

                <div class="content" style="overflow-y:auto;height: 52vh;">

                  <table class="table is-striped is-fullwidth" style="width:100% !important;" >
                    <thead>
                      <tr>
                        <th><abbr>ID</abbr></th>
                        <th>Alumno</th>
                        <th>
                          <div class="b-checkbox is-info" style="margin-left:5px">
                            <input id="cambiarAll" name="cambiarAll" class="styled" type="checkbox" [(ngModel)]="cambiarAll"
                            [checked]="cambiarAll" (change)="checkAll()" [ngModelOptions]="{standalone: true}">
                            <label for="cambiarAll" style="font-weight:bold; font-size:large;">
                              Cambiar?
                            </label>
                          </div>

                          </th>
                      </tr>
                    </thead>
                    <tbody formArrayName="grupos">
                      <tr *ngFor="let val of ctrl.dato.controls.grupos.controls; let i = index;" [formGroupName]="i">
                        <td style="vertical-align: middle;">{{ i + 1 }}</td>
                        <td style="vertical-align: middle;"><strong>{{ val.value.matricula }}</strong>
                          {{ val.value.nombre }} <!--<pre>{{ val.value | json }}</pre>--> </td>
                        <td style="vertical-align: middle;">
                          <div class="b-checkbox is-info" style="margin-left:5px">
                            <input id="cambiar{{i}}" name="cambiar{{i}}" class="styled" type="checkbox" formControlName="cambiar"
                              [checked]="val.get('cambiar').value == 1 ? true : false">
                            <label for="cambiar{{i}}" style="font-weight:bold; font-size:large;">
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="ctrl.dato.controls.grupos.length == 0">
                        <td colspan="3" style="vertical-align: middle; color:#888;">Sin alumnos en el grupo.</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </article>
          </div>


        </section>
      </form>
    </div>
  </div>
</div>
